import { BREAKPOINTS_DEVICES } from '../constants';

const getDevices = windowWidth => {
  const { TABLET, DESKTOP } = BREAKPOINTS_DEVICES;
  let devices = {
    isMobile: false,
    isTablet: false,
    isDesktop: false
  };

  if (windowWidth < TABLET) devices = { ...devices, isMobile: true };
  if (windowWidth > TABLET && windowWidth < DESKTOP) devices = { ...devices, isTablet: true };
  if (windowWidth > DESKTOP) devices = { ...devices, isDesktop: true };
  return devices;
};

export default getDevices;
